/* bc-footer.js — mobile accordion behaviour for footer nav columns.
 *
 * The details elements are server-rendered with [open] so desktop and
 * no-JS visitors always see the links. Below 990px this script collapses
 * them into accordions; above it, summaries are neutralised so they act
 * as plain headings. IDs deliberately avoid the "Details-" prefix so
 * global.js does not attach its own conflicting summary handlers.
 */
(() => {
  const mq = window.matchMedia('(max-width: 989px)');
  const detailsEls = document.querySelectorAll('.bc-footer__nav-details');
  if (!detailsEls.length) return;

  const apply = () => {
    detailsEls.forEach((details) => {
      const summary = details.querySelector('summary');
      if (mq.matches) {
        details.removeAttribute('open');
        summary.setAttribute('role', 'button');
        summary.removeAttribute('tabindex');
        summary.setAttribute('aria-expanded', 'false');
      } else {
        details.setAttribute('open', '');
        summary.removeAttribute('role');
        summary.removeAttribute('aria-expanded');
        summary.setAttribute('tabindex', '-1');
      }
    });
  };

  detailsEls.forEach((details) => {
    const summary = details.querySelector('summary');
    summary.addEventListener('click', (event) => {
      if (!mq.matches) {
        event.preventDefault();
        return;
      }
      summary.setAttribute('aria-expanded', !details.hasAttribute('open'));
    });
  });

  mq.addEventListener('change', apply);
  apply();
})();
